import { css, html } from 'lit';
import { FsHeading } from '@cof/fs-typography-wc/fs-heading';

export class RefiHeadingComponent extends FsHeading {
  static get styles() {
    const style = css``;
    return [style, ...FsHeading.styles];
  }

  render() {
    return html`
      <fs-heading class="header" level="1" size="medium" variant="primary">
        <slot></slot>
      </fs-heading>
    `;
  }
}

customElements.define('refi-heading', RefiHeadingComponent);
